var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldGalleryFavorite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.001 10.381a2.38 2.38 0 1 1 0-4.76 2.38 2.38 0 0 1 0 4.76z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8v4.61l-.13-.11c-.78-.67-2.04-.67-2.82 0l-4.16 3.57c-.78.67-2.04.67-2.82 0l-.34-.28c-.71-.62-1.84-.68-2.64-.14l-3.74 2.51c-.22-.56-.35-1.21-.35-1.97V7.81c0-2.82 1.49-4.31 4.31-4.31H16v-.47c0-.4.07-.74.23-1.03H7.81C4.17 2 2 4.17 2 7.81v8.38c0 1.09.19 2.04.56 2.84.86 1.9 2.7 2.97 5.25 2.97h8.38c3.64 0 5.81-2.17 5.81-5.81V7.77c-.29.16-.63.23-1.03.23h-.47z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.03 1c-.87 0-1.51.36-1.8 1-.16.29-.23.63-.23 1.03V5.97C16 7.24 16.76 8 18.03 8H20.97c.4 0 .74-.07 1.03-.23.64-.29 1-.93 1-1.8V3.03C23 1.76 22.24 1 20.97 1h-2.94zm1.47 5.5c-.45 0-1.73-.62-2.11-1.82a1.836 1.836 0 0 1-.02-1.07c.13-.47.44-.88.96-1.05.2-.06.41-.08.6-.04.2.03.39.11.56.24.32-.25.76-.33 1.18-.2.91.3 1.2 1.33.94 2.12-.04.12-.09.24-.15.35-.27.54-.73.94-1.16 1.18-.32.19-.63.29-.8.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGalleryFavorite);
export default __webpack_public_path__ + "static/media/vuesax-bold-gallery-favorite.5670ba1caa4f58da75fcce375eaad560.svg";
export { ForwardRef as ReactComponent };